import React from "react";
import { useLocation } from "react-router-dom";
import {
  FaBuilding,
  FaCalendarAlt,
  FaIdBadge,
  FaMapMarkerAlt,
  FaUserTie,
  FaEnvelope,
  FaPhone,
  FaMoneyBillWave,
  FaUsers,
  FaBriefcase,
} from "react-icons/fa";

export default function JobDescriptionPage() {
  const location = useLocation();
  const jobData = location.state;

  if (!jobData) {
    return (
      <div className="text-center text-xl font-semibold text-gray-600 mt-10">
        No job selected
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto mt-10 p-5">
      <div className="bg-white/80 backdrop-blur-lg shadow-xl rounded-2xl p-8 border border-gray-200">
        
        {/* Header */}
        <div className="mb-5">
          <h1 className="text-3xl font-bold text-blue-600 flex items-center gap-2">
            <FaBuilding /> {jobData.company}
          </h1>

          <p className="text-gray-500 flex items-center gap-2 mt-1">
            <FaCalendarAlt />
            {jobData.created_at?.split("T")[0]}
            <FaIdBadge className="ml-3" />
            {jobData.reqId}
          </p>
        </div>

        <hr className="my-4 border-gray-300" />

        {/* Job Description Section */}
        <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
          <FaBriefcase /> Job Description
        </h2>
        <p className="text-gray-700 mt-2">{jobData.jobDescription}</p>

        {/* Job Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">
          <div className="bg-gray-50 p-4 rounded-xl border">
            <p className="font-medium text-gray-800">
              <FaUserTie className="inline mr-2 text-blue-600" />
              Job Title:
              <span className="font-normal text-gray-600 ml-2">
                {jobData.title}
              </span>
            </p>
          </div>

          <div className="bg-gray-50 p-4 rounded-xl border">
            <p className="font-medium text-gray-800">
              <FaBriefcase className="inline mr-2 text-blue-600" />
              Experience:
              <span className="font-normal text-gray-600 ml-2">
                {jobData.work_exp_from} years
              </span>
            </p>
          </div>

          <div className="bg-gray-50 p-4 rounded-xl border">
            <p className="font-medium text-gray-800">
              <FaMoneyBillWave className="inline mr-2 text-green-600" />
              CTC:
              <span className="font-normal text-gray-600 ml-2">
                {jobData.annualCtc}
              </span>
            </p>
          </div>

          <div className="bg-gray-50 p-4 rounded-xl border">
            <p className="font-medium text-gray-800">
              <FaUsers className="inline mr-2 text-purple-600" />
              Vacancies:
              <span className="font-normal text-gray-600 ml-2">
                {jobData.vacancies}
              </span>
            </p>
          </div>

          <div className="bg-gray-50 p-4 rounded-xl border md:col-span-2">
            <p className="font-medium text-gray-800">
              <FaMapMarkerAlt className="inline mr-2 text-red-600" />
              Location:
              <span className="font-normal text-gray-600 ml-2">
                {jobData.country} {jobData.state} {jobData.city}
              </span>
            </p>
          </div>
        </div>

        <hr className="my-6 border-gray-300" />

        {/* Job Overview */}
        <h2 className="text-xl font-semibold text-gray-800">Job Overview</h2>
        <p className="text-gray-700 mt-2">{jobData.jobDescription}</p>

        <hr className="my-6 border-gray-300" />

        {/* Company Overview */}
        <h2 className="text-xl font-semibold text-gray-800">Company Overview</h2>
        <p className="text-gray-700 mt-2">{jobData.companyDescription}</p>

        <hr className="my-6 border-gray-300" />

        {/* Contact Details */}
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Contact Details
        </h2>

        <div className="space-y-2 text-gray-700">
          <p>
            <FaUserTie className="inline mr-2 text-blue-500" />
            <b>Name:</b> {jobData.spocName}
          </p>
          <p>
            <FaEnvelope className="inline mr-2 text-red-500" />
            <b>Email:</b> {jobData.spocEmail}
          </p>
          <p>
            <FaPhone className="inline mr-2 text-green-500" />
            <b>Phone:</b> {jobData.spocNumber}
          </p>
        </div>
      </div>
    </div>
  );
}
